import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App" }
const _hoisted_2 = { class: "App__tools" }
const _hoisted_3 = { class: "App__buttons" }
const _hoisted_4 = { class: "slider" }
const _hoisted_5 = { class: "App__main" }
const _hoisted_6 = { class: "App__help-canvas" }
const _hoisted_7 = {
  key: 0,
  class: "cover"
}
const _hoisted_8 = { class: "cover__content" }

import { onMounted, ref, watch } from "vue";
import { getImage, getImageSize } from "@/tools/image";
import {
    addImage,
    getResizedSize,
    getImageData,
    getInitialPoints,
    getInitialTriangles,
    drawTriangles,
    clearCanvas,
} from "@/tools/canvas";
import { Edit, Size } from "@/types";
import { useMainStore } from "@/stores/main";
import { splitWorstTriangle, updateTriangles } from "@/tools/triangles";
import { Triangle } from "@/types/";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useMainStore();

const original = ref<HTMLCanvasElement | null>(null);
const render = ref<HTMLCanvasElement | null>(null);
const triangle = ref<HTMLCanvasElement | null>(null);

const setCanvasses = (size: Size) => {
    if (render.value) {
        render.value.width = size.width;
        render.value.height = size.height;
        store.canvas.render.context = render.value.getContext("2d");
        store.canvas.render.size = size;
    }
    if (triangle.value) {
        triangle.value.width = size.width;
        triangle.value.height = size.height;
        store.canvas.triangle.context = triangle.value.getContext("2d");
        store.canvas.triangle.size = size;
    }
};

const intervalId = ref<number | null>(null);

const tick = () => {
    createTick();
};

const createTick = () => {
    const filtered = store.triangles.filter((t) => t.active);
    updateTriangles(
        store.canvas.triangle,
        filtered,
        store.imageData,
        store.correction
    );

    const edit: Edit = splitWorstTriangle(filtered);
    store.points.push(edit.newPoint);
    store.triangles.push(...edit.newTriangles);
    store.history.push(edit);
    store.currentEdit = store.history.length - 1;
    drawTriangles(store.canvas.render, filtered);
};

const start = () => {
    intervalId.value = setInterval(tick);
};

const stop = () => {
    if (intervalId.value) {
        clearInterval(intervalId.value);
        intervalId.value = null;
    }
};

const revertTo = (index: number) => {
    const newTriangles: Triangle[] = [];
    for (let i = index; i < store.history.length; i++) {
        const edit = store.history[i];
        newTriangles.push(...edit.newTriangles);
    }
    const activeTriangles = store.triangles.filter(
        (t) => !newTriangles.includes(t)
    );
    drawTriangles(store.canvas.render, activeTriangles);
    clearCanvas(store.canvas.triangle);
    drawTriangles(
        store.canvas.triangle,
        store.history[index].oldTriangles,
        [0, 0, 0]
    );
    store.currentEdit = index;
};

const hasImage = ref(false);
const file = ref(null);

const atUpload = async () => {
    hasImage.value = true;
    if (!file.value || !file.value.type.startsWith("image/")) {
        alert("Het bestand is geen afbeelding.");
        return;
    } else {
        const image = new Image();
        image.src = URL.createObjectURL(file.value);
        if (original.value) {
            const context = original.value.getContext("2d");
            if (context) {
                await init(context, image);
                start();
            }
        }
    }
};

const useFallback = async () => {
    hasImage.value = true;
    const image = new Image();
    image.src = "mick-jagger.png";
    if (original.value) {
        const context = original.value.getContext("2d");
        if (context) {
            await init(context, image);
            start();
        }
    }
};

const init = async (
    originalContext: CanvasRenderingContext2D,
    image: HTMLImageElement
) => {
    store.canvas.original.context = originalContext;
    const originalSize = (await getImageSize(image)) as Size;
    const size = getResizedSize(originalSize);
    store.canvas.original.size = size;
    setCanvasses(size);
    addImage(originalContext, image, size);
    store.imageData = getImageData(store.canvas.original);
    store.points = getInitialPoints(size);
    store.triangles = getInitialTriangles(store.points);
};

watch(
    () => store.currentEdit,
    (newVal) => {
        revertTo(newVal);
    }
);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_file_upload = _resolveComponent("v-file-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (intervalId.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              onClick: stop
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("stop", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              onClick: start
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Start", -1)
              ]))]),
              _: 1
            }))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_unref(store).history.length > 1)
          ? (_openBlock(), _createBlock(_component_v_slider, {
              key: 0,
              modelValue: _unref(store).currentEdit,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).currentEdit) = $event)),
              max: _unref(store).history.length - 1,
              min: 0,
              step: 1,
              "thumb-label": ""
            }, null, 8, ["modelValue", "max"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", null, _toDisplayString(_unref(store).history.length) + " splits ", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("canvas", {
        ref_key: "render",
        ref: render
      }, null, 512),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("canvas", {
          id: "original",
          ref_key: "original",
          ref: original
        }, null, 512),
        _createElementVNode("canvas", {
          id: "triangle",
          ref_key: "triangle",
          ref: triangle
        }, null, 512)
      ])
    ]),
    (!hasImage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_file_upload, {
              "browse-text": "Upload image",
              title: "Drag and drop an image to start Triangler",
              modelValue: file.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((file).value = $event)),
              onChange: atUpload,
              density: "default"
            }, null, 8, ["modelValue"]),
            _cache[5] || (_cache[5] = _createTextVNode(" Or just use an image of Mick Jagger: ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("img", {
              src: "mick-jagger.png",
              alt: "Mick Jagger",
              width: "100"
            }, null, -1)),
            _createVNode(_component_v_btn, { onClick: useFallback }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Use Mick Jagger", -1)
              ]))]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})